import { SWRConfig } from "swr";
import CalendarEvents from "../components/pages/marketing-tools/community/CalendarEvents";

const MOCK_CALENDAR_ID = "test-calendar";

const mockData = {
  [`/community/calendars/${MOCK_CALENDAR_ID}`]: {
    id: MOCK_CALENDAR_ID,
    name: "Team Events",
    items: [
      {
        id: "1",
        title: "Q3 Affiliate Kickoff Webinar",
        description:
          "Join us for our quarterly kickoff where we'll share new commission structures, upcoming promotions, and top affiliate strategies for Q3.",
        allow_rsvp: true,
        rsvp_limit: 100,
        has_rsvp: true,
        start_ts: Math.floor(Date.now() / 1000) + 3 * 24 * 3600,
        end_ts: Math.floor(Date.now() / 1000) + 3 * 24 * 3600 + 5400,
        banner: { url: "https://picsum.photos/seed/event1/800/400" },
        meeting_url: "https://zoom.us/j/123456789",
        location_url: null,
      },
      {
        id: "2",
        title: "In-Person Networking Meetup",
        description:
          "Connect with fellow affiliates and the GoAffPro team in San Francisco. Light refreshments provided.",
        allow_rsvp: true,
        rsvp_limit: 40,
        has_rsvp: false,
        start_ts: Math.floor(Date.now() / 1000) + 10 * 24 * 3600,
        end_ts: Math.floor(Date.now() / 1000) + 10 * 24 * 3600 + 7200,
        banner: { url: "https://picsum.photos/seed/event2/800/400" },
        meeting_url: null,
        location_url: "https://maps.google.com/?q=San+Francisco+CA",
      },
      {
        id: "3",
        title: "Advanced Content Strategy Workshop",
        description:
          "A deep-dive workshop on creating high-converting affiliate content across blogs, social media, and email.",
        allow_rsvp: true,
        rsvp_limit: 0,
        has_rsvp: false,
        start_ts: Math.floor(Date.now() / 1000) + 21 * 24 * 3600,
        end_ts: Math.floor(Date.now() / 1000) + 21 * 24 * 3600 + 3600,
        banner: { url: "" },
        meeting_url: "https://meet.google.com/abc-defg-hij",
        location_url: null,
      },
      {
        id: "4",
        title: "Summer Campaign Launch",
        description:
          "We launched our biggest summer sale campaign. Recordings and assets are available in the resources hub.",
        allow_rsvp: false,
        rsvp_limit: 0,
        has_rsvp: false,
        start_ts: Math.floor(Date.now() / 1000) - 14 * 24 * 3600,
        end_ts: Math.floor(Date.now() / 1000) - 14 * 24 * 3600 + 3600,
        banner: { url: "https://picsum.photos/seed/event4/800/400" },
        meeting_url: "https://zoom.us/j/987654321",
        location_url: null,
      },
    ],
  },
};

function TestPage() {
  return (
    <SWRConfig value={{ fallback: mockData }}>
      <div className="container py-4">
        <CalendarEvents calendarId={MOCK_CALENDAR_ID} />
      </div>
    </SWRConfig>
  );
}

export default TestPage;
